import {payChannelOptions} from "@/util/options";

let utils = {}
const payAmount = {
    0: {
        label: "待付款",
        labelEn: "Pending Payment",
    },
    1: {
        label: "实付",
        labelEn: "Actual payment",
    }
}
/**
 * 获取实际支付描述
 * @param status 0待付款 1待成团 2待发货 3待收货 4已完成 5已关闭
 * @param payTime 支付时间， 默认 null
 */
utils.getPayAmount = function (status, payTime) {
    return payTime ? payAmount[1] : payAmount[0]
}
/**
 * 获取支付方式
 * @param status 订单状态 0待付款 1待成团 2待发货 3待收货 4已完成 5已关闭
 * @param payChannel 支付渠道 0微信 1储值卡 2支付宝 3外币支付
 * @param payTime 支付时间，默认 null
 */
utils.getPayWay = (status, payChannel, payTime) => {
    if (payTime) {
        return `${payChannelOptions[payChannel].label} ${payChannelOptions[payChannel].labelEn}`
    } else {
        return `--`
    }
}

utils.getFormatDate = (date, format) => {
  let result = format;
  const newDate = new Date(date);
  const formatObj = {
    'M+': newDate.getMonth() + 1,
    'd+': newDate.getDate(),
    'h+': newDate.getHours(),
    'm+': newDate.getMinutes(),
    's+': newDate.getSeconds()
  };
  const yearReg = new RegExp('(y+)', 'i');
  if (yearReg.test(format)) {
    const yearExec = yearReg.exec(format)[0];
    result = result.replace(yearExec, `${newDate.getFullYear()}`.substring(4 - yearExec.length));
  }
  const key = Object.keys(formatObj);
  for (let i = 0; i < key.length; i += 1) {
    const timeReg = new RegExp(`(${key[i]})`);
    if (timeReg.test(format)) {
      const timeExec = timeReg.exec(format)[0];
      const value = `${formatObj[key[i]]}`;
      result = result.replace(timeExec, timeExec.length <= 1 ? value : `00${value}`.substring(value.length));
    }
  }

  return result;
}
export default utils